export const CSR_STATUS = {
  inProgress: "In Progress",
  generating: "Generating CSR file",
  ready: "Ready for download",
  errored: "CSR generation failed",
};

export const LS_STATUS = {
  inProgress: "In Progress",
  generating: "Generating Lay Summary file",
  aiSummaryReady: "AI Lay Summary Generated",
  ready: "Ready for download",
  errored: "Lay Summary generation failed",
  readyToStart: "Ready to start Lay Summary generation",
};

export const FILE_UPLOAD_STATUS = {
  uploading: "UPLOADING",
  uploaded: "UPLOADED",
  processed: "PROCESSED",
  errored: "ERROR",
};

export const FILES_STATUS = {
  progress: "progress",
  pending: "pending",
  warning: "warning",
  ready: "ready",
  readyEmpty: "readyEmpty",
};

export const DOCUMENT_TYPE = {
  csp: "CSP",
  sap: "SAP",
  tfl: "TFL",
};
